<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
            <template slot="header">
              <div class="row">
                <div class="col-md-6">
                  <h4 class="card-title">Trattamenti</h4>
                </div>
                <div class="col-md-6">
                  <fg-input type="date"
                          label="Giorno"
                          :disabled="saving"
                          v-model="giorno">
                  </fg-input>
                </div>
              </div>
            </template>
            <p v-if="loading" class="card-category">
              <center>{{ loadingText }}</center>
            </p>
            <div class="row" v-if="!loading">
              <div class="table-trattamenti" :style="{'padding-bottom':'90px','max-width':'100%','max-height':Math.max(200,window.height-200)+'px'}">
                <vue-scrolling-table class="table" deadAreaColor="#FFF">
                  <template slot="thead">
                    <tr>
                      <th style="width:160px !important;min-width:160px !important;max-width:160px !important; text-transform: none !important;">g/100L</th>
                      <th style="width:120px !important;min-width:120px !important;max-width:120px !important;" v-for="ortaggio in ortaggi">{{ ortaggio.nome }}</th>
                    </tr>
                  </template>
                  <template slot="tbody" style="padding-bottom: 150px;">
                    <tr v-for="farmaco in farmaci">
                      <td style="width:160px !important;min-width:160px !important;max-width:160px !important;">{{ farmaco.nome }}</td>
                      <td v-for="ortaggio in ortaggi" style="width:120px !important;min-width:120px !important;max-width:120px !important;white-space: nowrap; overflow:visible;">
                        <fg-input type="number"
                                  v-bind:class="{'trattamenti': true,'trattamenti-hide-text':(trattamento[farmaco.id][ortaggio.id]==0), 'trattamenti-disabled': saving}"
                                  v-model="trattamento[farmaco.id][ortaggio.id]"
                                  />
                                  <!--min=0-->
                          <!--hide-clear-button-->
                      </td>
                    </tr>
                  </template>
                </vue-scrolling-table>
              </div>
              <div style="width:100%; min-height:90px; margin-top:-90px;">
                <center style="color:red; font-weight:bold;">{{ erroreSalvataggio }}</center>
              </div>
              <div class="col-md-12 text-right">
                <button type="button" :disabled="saving" class="btn btn-info btn-fill" @click.prevent="salva">
                  Salva
                </button>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  import VueScrollingTable from 'vue-scrolling-table'
  
  export default {
    components: {
      Card,
      VueScrollingTable
    },
    data () {
      return {
        countCaricaGiorno: 0,
        saving: false,
        erroreSalvataggio: '',
        loading: true,
        loadingText: 'Caricamento in corso...',
        backendPath: 'trattamenti/report-giorno',
        giorno: null,
        farmaci: [],
        ortaggi: [],
        trattamento: [],
        window: {
          width: 0,
          height: 0
        }
      }
    },
    created () {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    },
    destroyed () {
      window.removeEventListener('resize', this.handleResize)
    },
    mounted () {
      var me = this
      me.$data.giorno = me.todayToString()
    },
    watch: {
      giorno (value) {
        var me = this
        me.caricaGiorno(value)
      }
    },
    methods: {
      handleResize () {
        this.window.width = window.innerWidth
        this.window.height = window.innerHeight
      },
      resettaData () {
        var me = this
        me.$data.loading = true
        me.$data.loadingText = 'Caricamento in corso...'
        me.$data.backendPath = 'trattamenti/report-giorno'
        me.$data.farmaci = []
        me.$data.ortaggi = []
        me.$data.trattamenti = []
      },
      caricaGiorno: function (giorno) {
        var me = this
        me.resettaData()
        var countCaricaGiorno = ++me.$data.countCaricaGiorno
        if (!giorno) {
          return
        }
        var url = process.env.API_URL + me.$data.backendPath + '/' + giorno
        var method = 'GET'
        var params = {}
        var successFn = function (data) {
          if (countCaricaGiorno !== me.$data.countCaricaGiorno) {
            return
          }
          var trattamento = {}
          for (var f in data.farmaci) {
            var idF = data.farmaci[f].id
            trattamento[idF] = {}
            for (var o in data.ortaggi) {
              var idO = data.ortaggi[o].id
              var d
              if (typeof data.dosi[idF] === 'undefined' || typeof data.dosi[idF][idO] === 'undefined') {
                d = 0
              } else {
                d = data.dosi[idF][idO]
              }
              trattamento[idF][idO] = d
            }
          }
          me.$data.loading = false
          me.$data.farmaci = data.farmaci
          me.$data.ortaggi = data.ortaggi
          me.$data.trattamento = trattamento
        }
        var errorFn = function (message) {
          if (typeof message === 'undefined') {
            message = 'Network Error'
          }
          me.$data.loadingText = 'Errore: ' + message
          me.ajaxErrorFn(message)
        }
        this.ajax(url, method, params, successFn, errorFn)
      },
      salva: function () {
        var me = this
        me.saving = true
        me.erroreSalvataggio = ''
        var dosi = {}
        var giorno = me.$data.giorno
        var trattamento = me.$data.trattamento
        for (var idF in trattamento) {
          for (var idO in trattamento[idF]) {
            if (trattamento[idF][idO]) {
              var dose = parseInt(trattamento[idF][idO])
              if (dose) {
                if (typeof dosi[idF] === 'undefined') {
                  dosi[idF] = {}
                }
                dosi[idF][idO] = dose
              }
            }
          }
        }
        var url = process.env.API_URL + me.$data.backendPath + '/' + giorno
        var method = 'PUT'
        var params = {
          dosi: dosi
        }
        var successFn = function (data) {
          me.successMessage('Dati salvati')
          me.saving = false
        }
        var errorFn = function (message) {
          if (typeof message === 'undefined') {
            message = 'Network Error'
          }
          me.$data.erroreSalvataggio = 'Errore: ' + message
          me.saving = false
          me.ajaxErrorFn(message)
        }
        this.ajax(url, method, params, successFn, errorFn)
      }
    }
  }

</script>
<style>
.trattamenti{
  width: 100% !important;
}
.trattamenti > input{
  cursor: pointer;
  width: 100% !important;
  text-align: right;
}
.trattamenti-hide-text > input{
  color:#FFF;
}
.trattamenti-disabled > input{
  pointer-events:none;
  background-color: #F5F5F5;
  color: #565656;
}
.trattamenti-disabled.trattamenti-hide-text > input{
  color: #F5F5F5;
}
.trattamenti-totali{
  text-align: right;
  font-weight: bold;
  padding: 12px 16px !important;
}
.table-trattamenti th{
  text-align: center !important;
}

.table-trattamenti thead td:first-child,
.table-trattamenti tbody td:first-child,
.table-trattamenti thead th:first-child,
.table-trattamenti tbody th:first-child {
	position: sticky;
	position: -webkit-sticky;
	left: 0;
  z-index:1;
  background-color: #f7f7f7;
}

.table-trattamenti tbody {
  padding-bottom:100px;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Trattamenti.vue